module.exports = __webpack_public_path__ + "static/014-1e62a6b6e3b0e53b4b81125728110bab.jpg";